module.exports = __webpack_public_path__ + "static/media/game_cover_archero2.aab0278a.png";